// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__1koGs","list":"PatternAutocomplete_list__3buUA"};